import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news22_1 from "../../images/news/news22_1.jpg";
import news22_2 from "../../images/news/news22_2.jpg";
import news22_3 from "../../images/news/news22_3.jpg";
import news22_4 from "../../images/news/news22_4.jpg";
import news22_5 from "../../images/news/news22_5.jpg";
import news22_6 from "../../images/news/news22_6.jpg";
import news22_7 from "../../images/news/news22_7.jpg";
import news22_8 from "../../images/news/news22_8.jpg";
import news22_9 from "../../images/news/news22_9.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

class news22 extends Component {
    componentDidMount() {}

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News22_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News22_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News22_LinkHome")}</Link>
                                </li>
                                <li>{t("News22_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News22_Content_H")}</h1>

                                            
                                            {/* P1 */}
                                            <ReactMarkdown>{t("News22_P1_MD")}</ReactMarkdown>

                                            {/* IMG 1 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_1}
                                                    alt={t("News22_IMG1_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News22_P2_MD")}</ReactMarkdown>

                                            {/* IMG 2 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_2}
                                                    alt={t("News22_IMG2_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG2_DESC")}
                                                </div>
                                            </div>

                                            {/* P3 */}
                                            <ReactMarkdown>{t("News22_P3_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_3}
                                                    alt={t("News22_IMG3_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG3_DESC")}
                                                </div>
                                            </div>
                                            
                                            {/* P4 */}
                                            <ReactMarkdown>{t("News22_P4_MD")}</ReactMarkdown>

                                            {/* IMG 4 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_4}
                                                    alt={t("News22_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News22_P5_MD")}</ReactMarkdown>

                                            {/* IMG 5 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_5}
                                                    alt={t("News22_IMG5_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG5_DESC")}
                                                </div>
                                            </div>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News22_P6_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_6}
                                                    alt={t("News22_IMG6_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News22_P7_MD")}</ReactMarkdown>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_7}
                                                    alt={t("News22_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P8 */}
                                            <ReactMarkdown>{t("News22_P8_MD")}</ReactMarkdown>
                                            
                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_8}
                                                    alt={t("News22_IMG8_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P9 */}
                                            <ReactMarkdown>{t("News22_P9_MD")}</ReactMarkdown>
                                            
                                            {/* IMG 9 */}
                                            <div style={{ textAlign: "center", margin: "22px 0" }}>
                                                <img
                                                    src={news22_9}
                                                    alt={t("News22_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "red" }}>
                                                    {t("News22_IMG9_DESC")}
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                
            </>
            
        );
    }
}

export default news22 = withTranslation()(news22);
